import './polyfills';

import {
  Repository,
  NetworkRepository,
  OfflineRepository,
  InmemoryOfflineRepository,
  KeyValueStoreOfflineRepository,
  KeyValuePersister,
  KeyValueStorePersister,
  MemoryKeyValuePersister,
  BrowserKeyValuePersister,
  SqlKeyValueStorePersister,
  IndexedDbKeyValueStorePersister,
  repositoryProvider
} from './datastore';

/**
 * @private
 */
export const DataAccess = {
  Repository,
  NetworkRepository,
  OfflineRepository,
  InmemoryOfflineRepository,
  KeyValueStoreOfflineRepository,
  KeyValuePersister,
  KeyValueStorePersister,
  MemoryKeyValuePersister,
  BrowserKeyValuePersister,
  SqlKeyValueStorePersister,
  IndexedDbKeyValueStorePersister,
  repositoryProvider
};

export { client, getAppVersion, setAppVersion, init, initialize, ping } from './kinvey';
export { Acl } from './acl';
export { Aggregation } from './aggregation';
export { AuthorizationGrant } from './identity';
export { Client } from './client';
export { CustomEndpoint } from './endpoint';
export { DataStore, DataStoreType, SyncOperation } from './datastore';
export { LiveServiceFacade as LiveService } from './live';
export { Files } from './files';
export { Log } from './log';
export { Metadata } from './metadata';
export { Query } from './query';
export { Properties, RequestMethod } from './request';
export { AuthType, KinveyRequest } from './request/network';
export { User } from './user';
export {
  ActiveUserError,
  APIVersionNotAvailableError,
  APIVersionNotImplementedError,
  AppProblemError,
  BadRequestError,
  BLError,
  CORSDisabledError,
  DuplicateEndUsersError,
  FeatureUnavailableError,
  IncompleteRequestBodyError,
  IndirectCollectionAccessDisallowedError,
  InsufficientCredentialsError,
  InvalidCredentialsError,
  InvalidIdentifierError,
  InvalidQuerySyntaxError,
  JSONParseError,
  KinveyError,
  KinveyInternalErrorRetry,
  KinveyInternalErrorStop,
  MissingQueryError,
  MissingRequestHeaderError,
  MissingRequestParameterError,
  MobileIdentityConnectError,
  NoActiveUserError,
  NetworkConnectionError,
  NoResponseError,
  NotFoundError,
  ParameterValueOutOfRangeError,
  PopupError,
  QueryError,
  ServerError,
  StaleRequestError,
  SyncError,
  TimeoutError,
  UserAlreadyExistsError,
  WritesToCollectionDisallowedError
} from './errors';



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/index.js